// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as AssetStore$PorterinFeature from "../../../../ui/assets/AssetStore.mjs";
import * as PnMStoreEn$PorterinFeature from "../../domain/store/PnMStoreEn.mjs";
import * as PaymentSuccessStore$PorterinFeature from "./payment-success/store/PaymentSuccessStore.mjs";
import * as PnMCallbackConfirmationModuleScss from "../styles/PnMCallbackConfirmation.module.scss";

var styles = PnMCallbackConfirmationModuleScss;

function PnMCallbackConfirmationCmp(Props) {
  var close_modal = Props.close_modal;
  React.useEffect((function () {
          setTimeout((function (param) {
                  Curry._1(close_modal, undefined);
                }), 3000);
        }), []);
  return React.createElement("div", {
              className: styles["pnm-callback-confirmation-container"]
            }, React.createElement("button", {
                  className: styles["close-modal-button"],
                  onClick: (function (param) {
                      Curry._1(close_modal, undefined);
                    })
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: AssetStore$PorterinFeature.crossIcon,
                      height: 24.0,
                      width: 24.0,
                      quality: 100.0,
                      alt: "close"
                    })), React.createElement("div", {
                  className: styles.title
                }, PnMStoreEn$PorterinFeature.confirmation_modal_title), React.createElement("div", {
                  className: styles["success-icon"]
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: PaymentSuccessStore$PorterinFeature.successImgUrl,
                      height: 128.0,
                      width: 128.0,
                      quality: 100.0,
                      alt: "success icon"
                    })), React.createElement("div", {
                  className: styles["sub-title"]
                }, PnMStoreEn$PorterinFeature.confirmation_modal_subtitle));
}

var make = PnMCallbackConfirmationCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
